import { render, staticRenderFns } from "./default.vue?vue&type=template&id=3f040f82"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/home/uattopspizzaco/builds/fZHTZxRpf/0/standbyteam/topspizza.co.uk/frontend/web/components/header/Header.vue').default,Footer: require('/home/uattopspizzaco/builds/fZHTZxRpf/0/standbyteam/topspizza.co.uk/frontend/web/components/footer/Footer.vue').default,CartItemAddedModal: require('/home/uattopspizzaco/builds/fZHTZxRpf/0/standbyteam/topspizza.co.uk/frontend/web/components/cart/CartItemAddedModal.vue').default})
